// Display labels for Hades. The VALUES are defined in
// cerberus/cerberus/hades/config.yaml (queues, work_categories) and stored as
// written; only the English lives here.
//
// A queue added to config.yaml with no entry here still renders — label() falls
// back to the raw key rather than dropping it.

export const QUEUE_LABELS = {
  // Not a verdict — the fleet has not reached this requirement yet. Given a
  // label and a rail slot so it is countable and filterable beside the real
  // queues, rather than being an invisible absence.
  not_investigated: 'Not investigated',
  unnoticed: 'Unnoticed',
  active: 'Active',
  awaiting_deploy: 'Awaiting deploy',
  recently_completed: 'Recently completed',
  shipped_record_stale: 'Shipped / record stale',
  necessary_unvoiced: 'Necessary / unvoiced',
  dormant: 'Dormant',
  irrelevant: 'Irrelevant',
  nice_to_have: 'Nice to have',
  needs_evidence: 'Unknown',
};

// Rail order is BY WHAT DEMANDS ATTENTION, not alphabetical and not by count.
// Shipped/stale first because it is the only closeable queue; Unnoticed second
// because it is the failure the system exists to surface; Unknown third because
// a rising count there means retrieval is degrading.
export const QUEUE_ORDER = [
  'shipped_record_stale', 'unnoticed', 'not_investigated', 'needs_evidence', 'active',
  'awaiting_deploy', 'recently_completed', 'necessary_unvoiced',
  'nice_to_have', 'dormant', 'irrelevant',
];

// The one queue with evidence strong enough to act on: delivery is a deploy
// state AND the record is still open, so a cited PR sits behind it.
// recently_completed often has no delivery proof; irrelevant needs a human to
// confirm the duplicate's target first.
export const CLOSEABLE_QUEUES = ['shipped_record_stale'];

export const CATEGORY_LABELS = {
  customer_feature: 'Customer feature',
  bug_fix: 'Bug fix',
  app_stability_reliability: 'Reliability',
  architecture_platform: 'Architecture',
  data_integration: 'Data integration',
  security_compliance: 'Security',
  internal_tooling: 'Internal tooling',
  documentation: 'Documentation',
  maintenance: 'Maintenance',
  unclassified: 'Unclassified',
};

export const LINKAGE_LABELS = {
  direct_customer_demand: 'Direct customer demand',
  indirect_customer_value: 'Indirect customer value',
  necessary_unvoiced: 'Necessary, unvoiced',
  no_established_link: 'No established link',
  unknown: 'Unknown',
};

export const DELIVERY_LABELS = {
  not_started: 'Not started',
  partial: 'Partial',
  implemented_unmerged: 'Implemented, unmerged',
  in_review: 'In review',
  merged_not_deployed: 'Merged, not deployed',
  deployed_unverified: 'Deployed',
  deployed_customer_confirmed: 'Deployed, confirmed',
  regressed: 'Regressed',
  closed_unmerged: 'Closed unmerged',
  unknown: 'Unknown',
};

// Canonical vocabulary is p0-p3/none (migration 0664). But 76 rows still hold
// the pre-0664 strings urgent/high/medium/low, so both are mapped — an
// unmapped value would render as raw 'medium' beside a column of 'P2'.
export const PRIORITY_LABELS = {
  p0: 'P0', p1: 'P1', p2: 'P2', p3: 'P3', none: '—',
  urgent: 'P0', high: 'P1', medium: 'P2', low: 'P3',
};

// Same fold, for grouping the flow chart. Legacy values must land in the same
// bucket as their canonical equivalent or a week's tickets split across two
// series that mean the same thing.
export const PRIORITY_CANONICAL = {
  urgent: 'p0', high: 'p1', medium: 'p2', low: 'p3',
};

export const canonicalPriority = (value) =>
  PRIORITY_CANONICAL[value] || value || 'none';

export const AXIS_LABELS = {
  validity: 'Validity',
  demand: 'Demand',
  delivery: 'Delivery',
  attention: 'Attention',
  evidence_quality: 'Evidence',
};

export const label = (map, key) => map[key] || key || '—';
